/**
 * /about page localized copy. Re-export shim over
 * /locales/{en,ht,fr,es}.json (about key). See /locales/README.md.
 */
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const COPY = {
  en: en.about,
  ht: ht.about,
  fr: fr.about,
  es: es.about,
  'pt-BR': ptBR.about,
  'zh-Hans': zhHans.about,
}

export default COPY
